// Calculator 1 - Voltage to Watts
const voltageInput = document.getElementById('voltageInput');

voltageInput.addEventListener('input', () => {

    const v = parseFloat(voltageInput.value) || 0;

    document.getElementById('w4').innerText = (v * v / 4).toFixed(1) + ' W';
    document.getElementById('w2').innerText = (v * v / 2).toFixed(1) + ' W';
    document.getElementById('w1').innerText = (v * v / 1).toFixed(1) + ' W';

});

// Calculator 2 - Watts to Voltage
const powerInput = document.getElementById('powerInput');

powerInput.addEventListener('input', () => {

    const p = parseFloat(powerInput.value) || 0;

    document.getElementById('v4').innerText = Math.sqrt(p * 4).toFixed(2) + ' V';
    document.getElementById('v2').innerText = Math.sqrt(p * 2).toFixed(2) + ' V';
    document.getElementById('v1').innerText = Math.sqrt(p * 1).toFixed(2) + ' V';

});
